export { type GraphemeDefinition, graphemeDefinitionTable } from "#grapheme-definition-table";
